import { useEffect, useRef } from "react";
import { CheckCircle2, Loader2, MousePointerClick } from "lucide-react";

/** بطاقة اختيار موحّدة لكل المنتجات: علامة «المختار» واضحة، تلميح «اضغط للاختيار»، وطبقة تحميل عند تغيير اللون مع الرجوع للعنصر المختار على الشاشة. */
export const PickCard = ({ active, busy, notice = "", onClick, testid, children, image, imageClass = "aspect-square", imageAlt = "" }) => {
  const ref = useRef(null);
  useEffect(() => {
    if (active && (busy || notice) && ref.current) ref.current.scrollIntoView({ behavior: "smooth", block: "center" });
  }, [active, busy, notice]);
  return (
    <button type="button" ref={ref} onClick={onClick} aria-pressed={active} data-testid={testid}
      className={`relative rounded-xl border p-2 text-start transition-[border-color,box-shadow,background-color] ${active ? "border-primary bg-primary/10 ring-2 ring-primary shadow-md" : "border-border bg-background hover:border-primary/50 hover:bg-primary/5"}`}>
      <span className={`absolute top-3 start-3 z-10 inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-[11px] font-bold shadow ${active ? "bg-primary text-white" : "bg-background/90 text-muted-foreground border border-border"}`} data-testid={`${testid}-badge`}>
        {active ? <><CheckCircle2 className="w-3.5 h-3.5" /> المختار</> : <><MousePointerClick className="w-3.5 h-3.5" /> اضغط للاختيار</>}
      </span>
      {image !== undefined && (
        <div className={`relative w-full ${imageClass} rounded-lg mb-2 overflow-hidden bg-secondary/60`}>
          {image ? <img src={image} alt={imageAlt} className="w-full h-full object-cover" draggable={false} />
            : <div className="w-full h-full flex items-center justify-center text-[11px] text-muted-foreground px-2 text-center">معاينة غير متاحة</div>}
          {active && busy && (
            <div className="absolute inset-0 bg-background/70 backdrop-blur-[2px] flex flex-col items-center justify-center gap-2 text-primary" data-testid={`${testid}-loading`}>
              <Loader2 className="w-7 h-7 animate-spin" />
              <span className="text-xs font-bold">جاري تغيير اللون حسب اختيارك…</span>
            </div>
          )}
          {active && !busy && notice && (
            <div className="absolute inset-x-0 bottom-0 bg-emerald-600/95 text-white text-[11px] font-bold px-2 py-1.5 flex items-center justify-center gap-1.5" data-testid={`${testid}-notice`}>
              <CheckCircle2 className="w-3.5 h-3.5 shrink-0" /> {notice}
            </div>
          )}
        </div>
      )}
      {children}
    </button>
  );
};

/** تنبيه واضح قبل الاختيار. */
export const PickHint = ({ show, text, testid }) => show ? (
  <p className="text-xs font-bold text-amber-800 dark:text-amber-300 bg-amber-50 dark:bg-amber-500/10 border border-amber-500/40 rounded-lg px-3 py-1.5 flex items-center gap-1.5 animate-pulse" data-testid={testid}>
    <MousePointerClick className="w-4 h-4 shrink-0" /> {text}
  </p>
) : null;
